import { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import { modalBackdrop, modalDialog, usePrefersReducedMotion } from '../effects/motionConfig';

export default function Modal({ isOpen, onClose, title, children }) {
  const dialogRef = useRef(null);
  const reduced = usePrefersReducedMotion();

  useEffect(() => {
    if (!isOpen) return undefined;

    const onKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
    };

    document.addEventListener('keydown', onKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    if (isOpen) dialogRef.current?.focus();
  }, [isOpen]);

  if (reduced) {
    if (!isOpen) return null;
    return (
      <div className="modal" onClick={onClose}>
        <div
          ref={dialogRef}
          className="modal__dialog"
          role="dialog"
          aria-modal="true"
          aria-labelledby={title ? 'modal-title' : undefined}
          tabIndex={-1}
          onClick={(event) => event.stopPropagation()}
        >
          <button type="button" className="modal__close" onClick={onClose} aria-label="Close">
            ×
          </button>
          {title && (
            <h2 id="modal-title" className="modal__sr-title">
              {title}
            </h2>
          )}
          {children}
        </div>
      </div>
    );
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal"
          onClick={onClose}
          initial="hidden"
          animate="visible"
          exit="exit"
          variants={modalBackdrop}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            ref={dialogRef}
            className="modal__dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby={title ? 'modal-title' : undefined}
            tabIndex={-1}
            onClick={(event) => event.stopPropagation()}
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={modalDialog}
          >
            <button type="button" className="modal__close" onClick={onClose} aria-label="Close">
              ×
            </button>
            {title && (
              <h2 id="modal-title" className="modal__sr-title">
                {title}
              </h2>
            )}
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
